const {
  REACT_APP_API_BASE_URL,
  REACT_APP_POST_HOG_KEY,
  REACT_APP_POST_HOG_HOST,
  REACT_APP_SOCKET_URL,
  REACT_APP_SENTRY_DNS,
} = process.env;

const config = {
  API: {
    url: REACT_APP_API_BASE_URL || "https://api.wishlink.com/api",
    postHogKey: REACT_APP_POST_HOG_KEY,
    postHogHost: REACT_APP_POST_HOG_HOST,
    wss: REACT_APP_SOCKET_URL || "ws://localhost:8000",
    sentry_dns: REACT_APP_SENTRY_DNS,
  },
};

export default config;

export const getAppBuildVersion = () => {
  let appBuild = 1000000000;
  try {
    if (window.ReactNativeWebView) {
      const injectedObject = JSON.parse(
        window.ReactNativeWebView.injectedObjectJson()
      );
      appBuild = Number(injectedObject?.appBuild) || appBuild;
    }
  } catch (error) {
    //
  }
  return appBuild;
};

export const getPlatform = (logError) => {
  let platform = "web";
  try {
    if (window.ReactNativeWebView) {
      const injectedObject = JSON.parse(
        window.ReactNativeWebView.injectedObjectJson()
      );
      platform = injectedObject?.platform || "unknown";
    }
  } catch (error) {
    platform = "error";
    if (logError) {
      logError({ log: "error - " + error, type: "error" });
    }
  }

  return platform;
};

export const getAppSessionUuid = () => {
  let appSessionUUID = "";
  try {
    if (window.ReactNativeWebView) {
      const injectedObject = JSON.parse(
        window.ReactNativeWebView.injectedObjectJson()
      );
      appSessionUUID = injectedObject?.appSessionUUID;
    }
  } catch (error) {
    //
  }
  return appSessionUUID;
};

export const getWebAppVersion = () => {
  // App version from package.json
  // This will be replaced by webpack DefinePlugin during build
  return process.env.REACT_APP_VERSION;
};
